import { render, staticRenderFns } from "./Gerencia.vue?vue&type=template&id=f3804d80&"
import script from "./Gerencia.vue?vue&type=script&lang=js&"
export * from "./Gerencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports